import { Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import * as React from "react";
import { Button, useRefresh } from "react-admin";
import { Link } from "react-router-dom";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import CustomDateTextInput from "../../unit/CustomDateTextInput";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import formatCurrency from "../../unit/formatCurrency";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import HeaderLabelValue from "../../unit/HeaderLabelValue";
import useNotify from "../../unit/useNotify";
import DialogApplicationBaseInfo from "../DialogApplicationBaseInfo";
import CustomApplicationDialogTitle from "./CustomApplicationDialogTitle";

export default function CustomApproved2DisburseFormDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record } = props;
  const [open, setOpen] = React.useState(false);
  const [dateClosing, setdateClosing] = React.useState("");
  let todayDate = dayjs().format("YYYY-MM-DD");
  const [transferDate, setTransferDate] = React.useState(todayDate);
  const [transferAmount, setTransferAmount] = React.useState();
  const refresh = useRefresh();
  const [disburseData, setDisburseData] = React.useState({});
  const handleClickOpen = () => {
    setOpen(true);
    const reqUrl = "applications/actions/getApplicationAccount";
    const fetchData = async () => {
      const responseData = await sendRequest(reqUrl, { id: appId });
      if (responseData) {
        setDisburseData(responseData?.data);
        if (responseData?.data?.sDestinationAccount == "Vendor Account") {
          setTransferAmount(responseData?.data?.amount_paid_3party);
        } else {
          setTransferAmount(responseData?.data?.fundAmount);
        }
      } else {
      }
    };
    fetchData();
  };

  const handleClose = () => {
    setOpen(false);
    refresh();
  };

  if (!disburseData) {
    return <div>Loading...</div>;
  }

  return (
    <React.Fragment>
      <Button
        id="btn-application-approved-disburse"
        label="Disburse"
        variant="contained"
        size="medium"
        color="success"
        sx={{
          marginLeft: "10px",
          width: "120px",
          "&:hover": { bgcolor: "gray" },
        }}
        onClick={handleClickOpen}
      />
      <Dialog
        id="dialog-application-approved-disburse"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="lg"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();

            let todayDisburseAmount = Number(disburseData?.todayDisburseAmount);
            let bank_dwolla_balance = Number(disburseData?.bank_dwolla_balance);
            let bank_min_dwolla_balance = Number(
              disburseData?.bank_min_dwolla_balance
            );
            if (todayDisburseAmount + transferAmount > bank_dwolla_balance) {
              errorNotify(
                "Total Disbursement Amount exceeds Dwoll Balance! Insufficient Dwolla Balance, Please refill balance"
              );
              return false;
            }
            if (
              disburseData?.user_sInstitutionName == "" ||
              disburseData?.user_sAccountType == "" ||
              disburseData?.user_sAccountNumber == "" ||
              disburseData?.user_sRoutingNumber == ""
            ) {
              errorNotify("User account info can't be empty");
              return false;
            }

            const reqUrl = `applications/actions/saveApplicationAccount`;
            const formData = new FormData();
            const formJson = Object.fromEntries((formData as any).entries());
            formJson.user_accountType = disburseData?.user_sAccountType;
            formJson.user_accountId = disburseData?.user_accountId;
            formJson.transferdate = transferDate;
            const response = await sendRequest(reqUrl, {
              id: appId,
              data: formJson,
            });
            if (
              response &&
              (response.status == "400" || response.code == 400)
            ) {
              let txt = "";
              if (response.error) {
                txt = response.error;
              } else {
                txt = "Missing Account Info or Funding Sources.";
              }
              errorNotify(txt);
            } else {
              let txt =
                "This transfer has been scheduled.  You and the applicant will be notified of its status via email.";

              if (
                disburseData?.sDisbursementUseDwollaBalance == "Yes" &&
                Number(disburseData?.bank_dwolla_balance) -
                  Number(transferAmount) <
                  Number(disburseData?.bank_min_dwolla_balance)
              ) {
                txt +=
                  "<br><span style='color:red;'>Dwolla balance will be below minimum balance of " +
                  "$" +
                  Number(disburseData?.bank_min_dwolla_balance) +
                  " after the transfer.  Please refill immediately.</span> ";
              }
              successNotify(txt);

              handleClose();
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomApplicationDialogTitle record={record} subTitle="Disburse" />
        </DialogTitle>
        <DialogContent>
          <DialogApplicationBaseInfo appId={appId} record={record} />
          <DialogContentText>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={4}>
                <HeaderLabelTitle title="Application ID" align="left" />
                <HeaderLabelValue value={appId} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <HeaderLabelTitle title="Loan Number" align="left" />
                <HeaderLabelValue value={record.sLoanNum} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <HeaderLabelTitle title="Reciplent Name" align="left" />
                <HeaderLabelValue value={record.sFname + ` ` + record.sLname} />
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 2, mb: 1 }}>
              <Grid item xs={12} sm={4}></Grid>
              <Grid item xs={12} sm={4}>
                <HeaderLabelTitle title="Transfer Amount" align="left" />
              </Grid>
              <Grid item xs={12} sm={4}>
                <HeaderLabelTitle title="Date of Transfer" align="left" />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}></Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  variant="outlined"
                  id="transferamount"
                  name="transferamount"
                  value={formatCurrency(transferAmount)}
                  aria-readonly
                  sx={{
                    "& input": { background: "#ddd", borderRadius: "10px" },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <CustomDateTextInput
                  id="transferdate"
                  name="transferdate"
                  value={transferDate}
                  required={true}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e?.target?.value != "") {
                      setTransferDate(e?.target?.value);
                    }
                  }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}></Grid>
              <Grid item xs={12} sm={4}>
                <HeaderLabelTitle title="Disbursing Account" align="left" />
              </Grid>
              <Grid item xs={12} sm={4}>
                {disburseData?.user_accountType == "Vendor Account" ? (
                  <HeaderLabelTitle title="Vendor Account" align="left" />
                ) : (
                  <HeaderLabelTitle title="Borrower Account" align="left" />
                )}
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}></Grid>
              <Grid item xs={12} sm={4}>
                {disburseData?.sDisbursementUseDwollaBalance == "Yes" && (
                  <Typography variant="body1">
                    Current Dwolla Balance :{" "}
                    {formatCurrency(disburseData?.dDwollaBalance)}
                    <br />
                    Pending Disbursement :
                    {formatCurrency(disburseData?.todayDisburseAmount)}
                    {/* <Link to="">Refill</Link> */}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12} sm={4}></Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <HeaderLabelTitle title="Financial Institution" />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  variant="outlined"
                  id="institutionname"
                  name="institutionname"
                  value={disburseData?.sInstitutionName}
                  aria-readonly
                  sx={{
                    "& input": { background: "#ddd", borderRadius: "10px" },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  variant="outlined"
                  id="user_institutionname"
                  name="user_institutionname"
                  value={disburseData?.user_sInstitutionName}
                  aria-readonly
                  sx={{
                    "& input": { background: "#ddd", borderRadius: "10px" },
                  }}
                />
              </Grid>
            </Grid>
            {/* Type of Account */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <HeaderLabelTitle title="Type of Account" />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  variant="outlined"
                  id="typeofaccount"
                  name="typeofaccount"
                  value={disburseData?.sAccountType}
                  aria-readonly
                  sx={{
                    "& input": { background: "#ddd", borderRadius: "10px" },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  variant="outlined"
                  id="user_typeofaccount"
                  name="user_typeofaccount"
                  value={disburseData?.user_sAccountType}
                  aria-readonly
                  sx={{
                    "& input": { background: "#ddd", borderRadius: "10px" },
                  }}
                />
              </Grid>
              {/* Routing Number */}
              <Grid item xs={12} sm={4}>
                <HeaderLabelTitle title="Routing Number" />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  variant="outlined"
                  id="routingnumber"
                  name="routingnumber"
                  value={disburseData?.sRoutingNumber}
                  aria-readonly
                  sx={{
                    "& input": { background: "#ddd", borderRadius: "10px" },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  variant="outlined"
                  id="user_routingnumber"
                  name="user_routingnumber"
                  value={disburseData?.user_sRoutingNumber}
                  aria-readonly
                  sx={{
                    "& input": { background: "#ddd", borderRadius: "10px" },
                  }}
                />
              </Grid>
              {/* Account Number */}
              <Grid item xs={12} sm={4}>
                <HeaderLabelTitle title="Account Number" />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  variant="outlined"
                  id="accountnumber"
                  name="accountnumber"
                  value={disburseData?.sAccountNumber}
                  aria-readonly
                  sx={{
                    "& input": { background: "#ddd", borderRadius: "10px" },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  variant="outlined"
                  id="user_accountnumber"
                  name="user_accountnumber"
                  value={disburseData?.user_sAccountNumber}
                  aria-readonly
                  sx={{
                    "& input": { background: "#ddd", borderRadius: "10px" },
                  }}
                />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          <CustomButtonSubmit label="Disburse" color="success" />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
